import {HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import * as moment from 'jalali-moment';
import {feedback} from '../app/app.module';
import {FeedBackService} from '../services/feed-back.service';
import {throwError} from 'rxjs';
import {YesNoDialogComponent} from '../Dialogs/yes-no-dialog/yes-no-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {FinanceService} from '../services/finance.service';

export interface TestStatus {
  englishLabel: string;
  persianLabel: string;
  online: boolean;
}

export class ValueWeight {
  public weight: number;

  constructor(public value: string) {
    this.weight = this.calculateWeight(value);
  }

  calculateWeight(str: string) {
    if (str.length < 7) {
      return 1;
    } else if (str.length < 17) {
      return 2;
    } else if (str.length < 26) {
      return 3;
    } else if (str.length < 33) {
      return 4;
    } else if (str.length < 44) {
      return 5;
    } else if (str.length < 54) {
      return 6;
    } else if (str.length < 63) {
      return 7;
    } else if (str.length < 72) {
      return 8;
    } else if (str.length < 83) {
      return 9;
    } else if (str.length < 93) {
      return 10;
    } else if (str.length < 103) {
      return 11;
    } else {
      return 12;
    }
  }
}

export class Item {
  public weight: number;
  public label: ValueWeight;
  public value: ValueWeight;

  constructor(label: string, value: string) {
    this.label = new ValueWeight(label);
    this.value = new ValueWeight(value);
    this.weight = this.label.weight + this.value.weight;
  }

  upgradeWeight(weight: number) {
    if (weight < this.weight) {
      throw new Error('new Weight cannot be less then current weight');
    } else if (weight > 12) {
      throw new Error('weight cannot be mre than 12');
    } else {
      const extraWeight = weight - this.weight;
      if (extraWeight) {
        this.upgrade(this.label, this.value, extraWeight);
      }
    }
  }

  upgrade(item1: ValueWeight, item2: ValueWeight, extraWeight: number) {
    if (item1.weight === item2.weight) {
      if (extraWeight % 2 === 0) {
        item1.weight += extraWeight / 2;
        item2.weight += extraWeight / 2;
      } else {
        item1.weight += (extraWeight - 1) / 2;
        item2.weight += (extraWeight - 1) / 2;
        item2.weight += 1;
      }
    } else if (item1.weight > item2.weight) {
      this.upgrade(item2, item1, extraWeight);
    } else {
      while (item1.weight !== item2.weight && extraWeight > 0) {
        item1.weight = item1.weight + 1;
        extraWeight--;
      }
      if (extraWeight) {
        this.upgrade(item1, item2, extraWeight);
      }
    }
  }
}

export interface RequestList {
  requests: any[];
  index: number;
  label: string;
  count: number;
}

export class DoctorReplyReport {
  public doctorReply: string;
  public doctorFirstName: string;
  public doctorLastName: string;
  public dateOfReply: string;
  public description: string;
  public headerClass: string;
  public panelClass: string;
  public report: string;
  public testsStatus: any[];
  public doctorReplyReport: any[];

  constructor() {
    this.doctorFirstName = '';
    this.doctorLastName = '';
    this.doctorReply = '';
    this.description = '';
    this.testsStatus = [];
    this.dateOfReply = '';
    this.doctorReplyReport = [];
  }

  populate(data: any) {
    for (const dataKey in data) {
      if (data.hasOwnProperty(dataKey)) {
        this[dataKey] = data[dataKey];
      }
    }
  }
}

export class PaymentInfo {
  public resnum: number;
  public amount: number;
  public amountString: string;
  public paymentURL: string;
  public portType: string;
  public discountsList: string[];
  public addedValue: any;
  public discountedAmount: number;
  public discountedAmountString: string;
  public discountSum: number;
  public discountSumString: string;
  public availablePaymentPorts: string[];
  public paymentPort: string[];
  public paymentMode: string;
  public translation: any[];
  public availablePaymentModes: string[];
  public htmlNotes: string;
  public personCount: number;
  public companyName: number;
  public duration: string;
  public offerName: string;
  public visitCost: string;
  public selectedPaymentPort: string;
  public franchise: string;
  public noDiscounts: boolean;
  public addedAmountString: string;

  constructor() {
    this.paymentMode = 'CASH';
  }

  setData(
    {
      res_num,
      amount,
      paymentURL,
      portType,
      discountsList,
      addedValue,
      discountedAmount,
      personCount,
      discountSum,
      availablePaymentModes,
      paymentMode,
      htmlNotes,
      availablePaymentPorts,
      selectedPaymentPort,
      paymentPort,
      companyName,
      translation,
      duration,
      visitCost,
      franchise,
      subRequestIDList,
      offerName,
      noDiscounts
    }) {
    this.resnum = res_num;
    this.amount = amount;
    this.amountString = StaticMethods.numberWithCommas(amount);
    this.paymentURL = paymentURL;
    this.portType = portType;
    this.discountsList = discountsList;
    this.addedValue = addedValue;
    this.selectedPaymentPort = selectedPaymentPort;
    this.discountedAmount = discountedAmount;
    this.discountedAmountString = StaticMethods.numberWithCommas(discountedAmount);
    this.discountSum = discountSum;
    this.discountSumString = StaticMethods.numberWithCommas(discountSum);
    this.availablePaymentModes = availablePaymentModes;
    this.paymentMode = paymentMode;
    this.translation = translation;
    this.htmlNotes = htmlNotes;
    this.personCount = personCount ? personCount : subRequestIDList ? subRequestIDList.length : 0;
    this.offerName = offerName;
    this.paymentMode = paymentMode;
    this.htmlNotes = htmlNotes;
    this.franchise = franchise;
    this.duration = duration;
    this.paymentPort = paymentPort;
    this.availablePaymentPorts = availablePaymentPorts;
    this.visitCost = visitCost;
    this.companyName = companyName;
    this.noDiscounts = noDiscounts;
    if (this.addedValue && this.addedValue.addedAmount) {
      this.addedAmountString = StaticMethods.numberWithCommas(this.addedValue.addedAmount);
    }
    if (this.visitCost) {
      this.visitCost = StaticMethods.numberWithCommas(this.visitCost);
    }
    if (duration) {
      this.offerName = 'بیمه ' + this.companyName + ' - ' + StaticMethods.getTranslation(this.duration);
    }
    if (franchise) {
      this.offerName = 'بیمه ' + this.companyName + ' - ' + StaticMethods.getTranslation(this.franchise);
    }
  }
}

export interface UploadInfo {
  englishName: string;
  persianName: string;
  id: number;
}

export class State {
  // tslint:disable-next-line:variable-name
  constructor(private readonly _stateCode?: string, private readonly _persianName?: string) {
    if (!_stateCode) {
      this._stateCode = '';
      this._persianName = '';
    }
  }

  stateCode() {
    return this._stateCode;
  }

  persianName() {
    return this._persianName;
  }
}

export class Option {
  constructor(public label: string, public value: any) {
  }
}

export class City {
  // tslint:disable-next-line:variable-name
  constructor(private _cityCode?: string, private _persianName?: string) {
    if (!_cityCode) {
      this._cityCode = '';
      this._persianName = '';
    }
  }

  cityCode() {
    return this._cityCode;
  }

  persianName() {
    return this._persianName;
  }
}

export class Link {
  constructor(public label: string, public url: string, public icon: string) {
  }
}

export class Response {
  constructor(public status: number, public success: boolean, public translation: any, public data?: any, public message?: string) {
    if (!success) {
      if (message) {
        StaticMethods.showMessage(message);
      } else {
        StaticMethods.showError('سرور در دسترس نمی باشد');
      }
    }
  }
}

export class HttpOption {
  headers?: HttpHeaders;
  params?: HttpParams;
}

export class Label {
  constructor(private englishLabel: string, private persianLabel: string) {
  }

  getEnglishLabel() {
    return this.englishLabel;
  }

  getPersianLabel() {
    return this.persianLabel;
  }
}

export class StaticMethods {
  static icons = {
    insurance: 'verified_user',
    companyName: 'apartment',
    agentCode: 'dialpad',
    securityCode: 'dialpad',
    stateCode: 'room',
    cityCode: 'room',
    birthday: 'cake',
    basicInsurance: 'verified_user',
    gender: 'wc',
    relation: 'people',
    weight: 'vertical_align_bottom',
    height: 'vertical_align_top',
    user: 'account_circle',
    delete: 'delete_sweep',
    password: 'lock_open',
    location: 'room',
    payment: 'shopping_cart',
    price: 'shopping_cart',
    error: 'warning',
    profile: 'contact_mail',
    email: 'email',
    mobile: 'stay_primary_portrait',
    deviceModel: 'stay_primary_portrait',
    phone: 'phone',
    image: 'image',
    education: 'school',
    default: 'filter_vintage'
  };

  static vocabulary = {
    ME: 'خودم',
    PARTNER: 'همسر',
    CHILD: 'فرزند',
    MALE: 'مرد',
    FEMALE: 'زن',
    true_FILE_STATUS: 'بارگذاری شده',
    false_FILE_STATUS: 'بارگذاری  نشده',
    true_TEST_STATUS: 'انجام نشد',
    false_TEST_STATUS: 'انجام نشد',
    FEMALE_TITLE: 'خانم',
    MALE_TITLE: 'آقا',
    false_SUBMISSION_STATUS: 'ارسال نشده',
    true_SUBMISSION_STATUS: 'موجود',
    NO_REPLY_DOCTOR: 'پزشک پاسخ نداده است',
    NO_REPLY: 'پاسخ نداده است',
    ACCEPT_DOCTOR: 'تایید شده توسط پزشک',
    REJECT_DOCTOR: 'لغو شده توسط پزشک',
    TEST_DOCTOR: 'آزمایش',
    NationalCard: 'کارت ملی',
    BirthCertificate: 'شناسنامه',
    InsuranceCard: 'دفترچه بیمه',
    CompanyName: 'نام شرکت',
    DentalSupport: 'پوشش دندانپزشکی',
    SurgerySupportA: 'پوشش جراحی های مهم',
    SurgerySupportB: 'پوشش جراحی مجاز سرپایی',
    MedicineSupport: 'پوشش ویزیت و دارو',
    PregnancySupport: 'پوشش زایمان',
    MTestSupport: 'پوشش خدمات آزمایشگاهی',
    ParaClinicSupportA: 'پوشش پاراکلینیک A',
    ParaClinicSupportB: 'پوشش پاراکلینیک B',
    HospitalSupport: 'پوشش بیمارستان',
    AmbulanceSupport: 'پوشش آمبولانس',
    totalPrice: 'مبلغ قابل پرداخت (حق بیمه یک ساله)',
    fileUploaded: 'در انتظار اپلود مدارک',
    formSubmitted: 'در انتظار تکمیل اطلاعات',
    doctorReplied: 'در انتظار پاسخ پزشک',
    paid: 'در انتظار پرداخت حق بیمه',
    testUploaded: 'در انتظار اپلود ازمایش',
    offerSelected: 'در انتظار انتخاب طرح',
    MARRIED: 'متاهل',
    SINGLE: 'مجرد',
    waitingForRelease: 'در انتظار صدور بیمه نامه',
    'DIPLOMA/JUNIOR_DIPLOMA': 'دیپلم - زیر دیپلم',
    'UNDERGRADUATE/BACHELOR': 'کارشناسی/ کاردانی',
    MASTER: 'کارشناسی ارشد',
    PHD: 'دکترا',
    age: 'سن',
    relation: 'رابطه',
    gender: 'جنسیت',
    Weight: 'وزن',
    Height: 'قد',
    DateOfCreation: 'تاریخ درخواست',
    FormsSubmission: 'اطلاعات',
    doctorReplyStatus: 'جواب پزشک',
    employeeReply: 'جواب شرکت بیمه',
    offer: 'طرح',
    TEST: 'نیاز به ازمایش دارد',
    ACCEPT: 'قبول شد',
    REJECT: 'رد شد',
    true: 'موجود',
    true_payment: 'پرداخت شده است',
    false: 'موجود نیست',
    false_payment: 'پرداخت نشده است',
    status: 'وضعيت',
    paid_label: 'حق بيمه',
    deviceType: 'نوع',
    deviceBrand: 'برند',
    deviceModel: 'مدل',
    franchise: 'فرانشیز',
    price: 'قیمت',
    companyName: 'نام شرکت بیمه',
    devicePrice: 'قیمت دستگاه',
    DeviceFrontPicture: 'تصویر جلو دستگاه با IMEI',
    DeviceBackPicture: 'تصویر پشتی دستگاه',
    DeviceBoxPicture: 'تصویر جعبه دستگاه',
    insuranceReleased: 'صادر شده',
    deviceInfo: 'اطلاعات دستگاه',
    personalInfo: 'اطلاعات بیمه گذار',
    '1_YEAR': 'یک ساله',
    '6_MONTH': 'شش مامه',
    DAYS90: '90 روزه',
    DAYS180: '180 روزه',
    DAYS365: '365 روزه',
    requestToken: 'کد پیگیری',
    requestID: 'کد درخواست',
    healthInfo: 'اطلاعات پزشکی',
    workInfo: 'اطلاعات پزشکی',
    death: 'سرمایه فوت، نقص عضو و از کارافتادگی ناشی از حادثه',
    doctor: 'هزینه پزشکی ناشی از حادثه',
    hospital: 'غرامت روزانه بستری بیمارستانی (بمدت یک ماه)',
    stateName: 'استان',
    cityName: 'شهر',
    birthday: 'تاریخ تولد',
    offerName: 'نام طرح',
    duration: 'مدت',
    name: 'نام',
    type: 'نوع',
    address: 'آدرس',
    onlineLetter: 'معرفی نامه آنلاین',
    telephone: 'تلفن',
    exists: 'دارد',
    notExists: 'ندارد',
    current_location: 'موقعیت فعلی',
    HEALTH: 'بیمه درمان تکمیلی خانواده',
    MOBILE: 'بیمه تجهیزات الکترونیک',
    INDIVIDUAL_ACCIDENTS: 'بیمه کرونا',
    INTRODUCTION_LETTER: 'معرفی نامه',
    mobile: 'بیمه شماره همراه',
    DoctorOrder: 'دستور پزشک',
    employeeReplied: 'در انتظار پاسخ شرکت بیمه',
    insuranceNumber: 'شماره بیمه نامه',
    productName: 'نام محصول',
    firstName: 'نام',
    lastName: 'نام خانواگی',
    centerName: 'نام مرکز',
    dateOfSubmission: 'تاریخ ثبت',
    letterType: 'نوع معرفی نامه',
    UNCHECKED: 'بررسی نشد',
    ACCEPTED: 'تایید شد',
    REJECTED: 'رد شد',
    rejected: 'رد شد',
    position: '#',
    id: 'کد',
    time: 'زمان',
    date: 'تاریخ',
    RECOMPENSE: 'خسارت',
    sendingDocument: 'در انتظار ارسال مدارک',
    documentRejected: 'عدم تطابق مدارک',
    documentAccepted: 'تایید پرداخت',
    documentTest: 'نقص مدارک',
    Bill: 'صورت حساب',
    HEALTH_GROUP: 'درمان گروهي',
    PET: 'حیوان خانگی',
    VisitTypeSelected: 'در انتظار انتخاب نوع ویزیت',
    ON_DOOR: 'درب منزل',
    IN_CLINIC: 'حضوری (در کلینیک)',
    waitingForVetReply: 'در انتظار جواب دامپزشک',
    visitSessionBooked: 'در انتظار انتخاب زمان ویزیت',
    day: 'روز',
    startHour: 'از ساعت',
    endHour: 'تا ساعت',
    clinicCount: 'تعداد کلینیک'
  };

  static dynamicParse(value, type) {
    if (typeof value === type) {
      return value;
    } else {
      switch (type) {
        case 'string':
          return value + '';
        case 'number':
          return parseInt(value, 10);
        case 'boolean':
          return !(!value);
        default:
          return value;
      }
    }
  }

  static appendTranslation(responseTranslation, translation) {
    for (const key in responseTranslation) {
      if (responseTranslation.hasOwnProperty(key)) {
        if (!translation[key]) {
          translation[key] = responseTranslation[key];
        }
      }
    }
    return translation;
  }

  static arranger(object: any, preferableWeight: number) {

  }

  static setStep(scenario: Scenario, checkStepStatus, object) {
    let currentStep = '';
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < scenario.getStepSequence().length && currentStep === ''; i++) {
      if (!checkStepStatus(scenario.getStepSequence()[i], object)) {
        currentStep = scenario.getStepSequence()[i];
      }
    }
    return currentStep;
  }

  public static loadScript(url: string) {
    const body = document.body as HTMLDivElement;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  static numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  static checkState(router: Router, stateNames: string[] | string, url?: string | string[]) {
    let notSet = false;
    let index = null;
    if (typeof stateNames === 'object') {
      if (typeof url === 'object') {
        if (stateNames.length !== url.length) {
          throw new Error('stateName array length must be equal to url array length');
        } else {
          for (let i = 0; i < stateNames.length; i++) {
            if (!history.state[stateNames[i]]) {
              index = i;
              notSet = true;
            }
          }
        }
      } else {
        stateNames.forEach(name => {
          notSet = !history.state[name];
        });
      }
    } else {
      notSet = !history.state[stateNames];
    }
    if (notSet) {
      if (index !== null) {
        const state = {};
        for (let i = 0; i <= index; i++) {
          state[stateNames[i]] = history.state[stateNames[i]];
        }
        router.navigate([url[index]], {state});
      } else {
        router.navigate([url]);
      }
    }
    return !notSet;
  }

  static preserveList(viewList) {
    const viewInformation = {};
    for (const key in viewList) {
      if (viewList.hasOwnProperty(key)) {
        viewInformation[key] = history.state.viewList[key];
        console.log(key, history.state.viewList[key]);
      } else {
        console.log(key, 'not set');
      }
    }
    return viewInformation;
  }

  static getjalaliDate(date: Date) {
    const newDate = DateMethods.getJalaliDate(date);
    return DateMethods.getJalaliDate(date);
  }

  static calculateDuration(delta: number): string {
    // calculate (and subtract) whole days
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;

// calculate (and subtract) whole hours
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

// calculate (and subtract) whole minutes
    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

// what's left is seconds
    const seconds = parseInt((delta % 60) + '', 10);

// Will display time in 10:30:23 format
    return (hours + '00').substr(-3) + ':' + ('0' + hours).substr(-2) + ':' + ('0' + minutes).substr(-2) + ':' + ('0' + seconds).substr(-2);
  }

  static calculateDistance(distance: number) {
    return (distance / 1000).toFixed(1);
  }

  static handleError(err: HttpErrorResponse | any, feedbackService: FeedBackService) {
    console.error('An error occurred', err);
    let errorMessage = '';
    if (err.error.message) {
      errorMessage = err.error.message;
    } else {
      // errorMessage = `error code: ${err.status}\nMessage: ${err.message}`;
      errorMessage = `دسترسی به اینترنت قطع می باشد دوباره تلاش کنید`;
    }
    feedbackService.showMessage(errorMessage);
    return throwError(err.message || err);
  }

  static getBaseUrl(productName, role?: string) {
    switch (role) {
      case 'user':
        break;
      case 'external-employee':
        return 'external-employee';
    }
    switch (productName) {
      case 'HEALTH_GROUP':
        return 'HEALTH_GROUP';
      case 'PET':
        return 'PET';
      case 'HEALTH':
        return 'health/family';
      case 'INDIVIDUAL_ACCIDENTS':
        return 'individual-accidents';
      case 'INTRODUCTION_LETTER':
        return 'insurance-service/INTRODUCTION_LETTER';
      case 'RECOMPENSE':
        return 'insurance-service/RECOMPENSE';
      case 'MOBILE':
        return 'mobile';
      case 'EXTERNAL_EMPLOYEE':
        return 'external-employee';
    }
  }

  static getProductName(router: Router, required: boolean) {
    const currentUrl = router.url;
    if (currentUrl.includes('HEALTH_GROUP')) {
      return 'HEALTH_GROUP';
    }
    if (currentUrl.includes('PET')) {
      return 'PET';
    }
    if (currentUrl.includes('health/family') || currentUrl.includes('HEALTH')) {
      return 'HEALTH';
    }
    if (currentUrl.includes('individual-accidents') || currentUrl.includes('INDIVIDUAL_ACCIDENTS')) {
      return 'INDIVIDUAL_ACCIDENTS';
    }
    if (currentUrl.includes('introduction-letter') || currentUrl.includes('INTRODUCTION_LETTER')) {
      return 'INTRODUCTION_LETTER';
    }
    if (currentUrl.includes('RECOMPENSE')) {
      return 'RECOMPENSE';
    }
    if (currentUrl.includes('external-employee') || currentUrl.includes('EXTERNAL_EMPLOYEE')) {
      return 'EXTERNAL_EMPLOYEE';
    }
    if (currentUrl.includes('mobile') || currentUrl.includes('MOBILE')) {
      return 'MOBILE';
    }
    if (required) {
      this.showError('product name not initialized');
    }
    return 'NOT_SET';
  }

  static onCoworkerLoginInit(anime) {
    let current = null;
    document.querySelector('#email').addEventListener('focus', (e) => {
      if (current) {
        current.pause();
      }
      current = anime({
        targets: 'path',
        strokeDashoffset: {
          value: 0,
          duration: 700,
          easing: 'easeOutQuart'
        },
        strokeDasharray: {
          value: '240 1386',
          duration: 700,
          easing: 'easeOutQuart'
        }
      });
    });
    document.querySelector('#password').addEventListener('focus', (e) => {
      if (current) {
        current.pause();
      }
      current = anime({
        targets: 'path',
        strokeDashoffset: {
          value: -336,
          duration: 700,
          easing: 'easeOutQuart'
        },
        strokeDasharray: {
          value: '240 1386',
          duration: 700,
          easing: 'easeOutQuart'
        }
      });
    });
    document.querySelector('#submit').addEventListener('focus', (e) => {
      if (current) {
        current.pause();
      }
      current = anime({
        targets: 'path',
        strokeDashoffset: {
          value: -730,
          duration: 700,
          easing: 'easeOutQuart'
        },
        strokeDasharray: {
          value: '530 1386',
          duration: 700,
          easing: 'easeOutQuart'
        }
      });
    });
  }

  static fillForms(router: Router, productName: string, requestID: number, icon: string, subRequestID?: number) {
    router.navigate([`/notes/${productName}/${requestID}`], {
      state: {
        requestID,
        icon,
        subRequestID
      }
    });
  }

  static redirectToPayment(paymentInfo: PaymentInfo,
                           dialog: MatDialog,
                           financeService: FinanceService,
                           productName: string,
                           paymentMode: string,
                           cb) {
    if (paymentMode === 'INSTALLMENT') {
      cb(false);
      StaticMethods.openDialog(dialog,
        paymentInfo.htmlNotes, (result) => {
          if (result) {
            goToLink();
          } else {
            cb(true, 'CASH');
          }
        }, '450px', true, true);
    } else {
      goToLink();
    }

    function goToLink() {
      console.log(paymentInfo.selectedPaymentPort);
      switch (paymentInfo.selectedPaymentPort) {
        case 'B2B':
          StaticMethods.openDialog(dialog, 'آز اعلام پرداخت شدن این درخواست مطمئن هستید؟', (result) => {
            if (result) {
              financeService.B2BPaymentCallback(productName,
                paymentInfo.resnum,
                paymentInfo.amount).subscribe((response => {
                if (response.success) {
                  history.back();
                }
              }));
            }
          });
          break;
        case 'ZP':
          if (paymentInfo.paymentURL) {
            StaticMethods.goToLink(paymentInfo.paymentURL);
          }
          break;
        default:
          StaticMethods.showMessage('port type not supported');
      }
    }
  }

  static openDialog(dialog: MatDialog, message: string, cb: any, width?: string,
                    confirmRequired?: boolean, htmlMessage?: boolean, checkBoxLabel?: string): void {
    width = width ? width : '250px';
    checkBoxLabel = checkBoxLabel ? checkBoxLabel : 'شرایط ذکر شده را خواندم و تایید می کنم';

    const dialogRef = dialog.open(YesNoDialogComponent, {
      width,
      data: {
        checkBoxLabel,
        message,
        confirmRequired,
        htmlMessage
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      cb(result);
    });
  }

  static checkParams(router: Router, activeRoute: ActivatedRoute, stateNames: string[] | string, url?: string | string[]): boolean {
    activeRoute.queryParams.subscribe((params: Params) => {
      let notSet = false;
      let index = null;
      if (typeof stateNames === 'object') {
        if (typeof url === 'object') {
          if (stateNames.length !== url.length) {
            throw new Error('stateName array length must be equal to url array length');
          } else {
            for (let i = 0; i < stateNames.length; i++) {
              if (!params[stateNames[i]]) {
                index = i;
                notSet = true;
              }
            }
          }
        } else {
          stateNames.forEach(name => {
            notSet = !params[name];
          });
        }
      } else {
        notSet = !params[stateNames];
      }
      if (notSet) {
        if (index !== null) {
          const state = {};
          for (let i = 0; i <= index; i++) {
            state[stateNames[i]] = params[stateNames[i]];
          }
          router.navigate([url[index]], {state});
        } else {
          router.navigate([url]);
        }
      }
      return !notSet;
    }, () => {
      return false;
    });
    return false;
  }

  static getIcon(fieldName) {
    return this.icons[fieldName] ? this.icons[fieldName] : this.icons.default;
  }

  static getTranslation(label: string) {
    return this.vocabulary[label] ? this.vocabulary[label] : label;
  }

  static goToLink(url) {
    window.open(url, '_blank');
  }

  static showError(message) {
    // alert(message);
    feedback.showMessage(message);
  }

  static showMessage(message) {
    // alert(message);
    feedback.showMessage(message);
  }

  static getProductIcon(productName: string) {
    switch (productName) {
      case 'MOBILE':
        return 'ico-smartphone-outline';
      case 'HEALTH':
        return 'ico-umbrella-outline';
      case 'INDIVIDUAL_ACCIDENTS':
        return 'icon ico-person-outline';
      case 'INTRODUCTION_LETTER':
        return 'icon ico-person-outline';
      default:
        return 'ico-umbrella-outline';
    }
  }

  static getRole(url: string) {
    if (url.indexOf('external-employee') !== -1) {
      return 'external-employee';
    } else if (url.indexOf('agent') !== -1) {
      return 'agent';
    } else if (url.indexOf('doctor') !== -1) {
      return 'doctor';
    } else {
      return 'user';
    }
    return undefined;
  }

  static prepareProductName(productName: string) {
    productName = productName.toUpperCase();
    productName = productName.replace('-', '_');
    return productName;
  }
}

export class Scenario {

  constructor(private stepSequence: string[]) {
  }

  getStepSequence(): string[] {
    return this.stepSequence;
  }
}

export class Question {
  private readonly id: number;
  private readonly persianLabel: string;
  private readonly englishLabel: string;
  private readonly required: string;
  private readonly description: string;
  private answer: any;
  private dataType: string[];
  private readonly subQuesionsList?: Question[];

  constructor(questionJsonData: any, formGroup: FormGroup) {
    this.id = questionJsonData.id;
    this.persianLabel = questionJsonData.persianLabel;
    this.englishLabel = questionJsonData.englishLabel;
    this.required = questionJsonData.required;
    this.answer = questionJsonData.answer;
    this.description = questionJsonData.description;
    this.setDataType(questionJsonData.dataType);
    const validators: ValidatorFn[] = [];
    if (this.isRequired()) {
      validators[validators.length] = Validators.required;
    }
    if (this.getDataType() && typeof this.getDataType()[1] === 'string' && this.getDataType()[1] !== '') {
      // validators[validators.length] = Validators.minLength(parseInt(this.getDataType()[1], 10));
      if (this.getDataType()[0] === 'number') {
        let max = 1;
        for (let i = 0; i < this.getDataType()[1]; i++) {
          max *= 10;
        }
        max--;
        validators[validators.length] = Validators.max(max);
      } else {
        validators[validators.length] = Validators.maxLength(parseInt(this.getDataType()[1], 10));
      }
    }
    const name = this.getEnglishLabel().toLowerCase();
    if (name.indexOf('email') !== -1) {
      // validators[validators.length] = Validato rs.email;
    }
    const dataTypeLowerCase = this.getDataType()[0].toLowerCase();
    if (dataTypeLowerCase.indexOf('list') === -1) {
      formGroup.addControl(this.getEnglishLabel(), new FormControl('', validators));
    }
    this.subQuesionsList = [];
    if (questionJsonData.subQuesionsList) {
      questionJsonData.subQuesionsList.forEach(item => {
        const index = this.subQuesionsList.length;
        this.subQuesionsList[index] = new Question(item, formGroup);
      });
    }
  }

  getID(): number {
    return this.id;
  }

  getAnswer(): string {
    return this.answer;
  }

  getPersianLabel(): string {
    return this.persianLabel;
  }

  getEnglishLabel(): string {
    return this.englishLabel;
  }

  isRequired(): boolean {
    return this.required === 'YES';
  }

  getDescription(): string {
    return this.description;
  }

  getDataType(): any[] {
    return this.dataType;
  }

  private setDataType(dataType) {
    switch (dataType) {
      case 'varchar':
        this.dataType = ['text'];
        break;
      case 'number':
        this.dataType = ['number'];
        break;
      case 'TINYINT':
        this.dataType = ['checkbox'];
        break;
      case 'text':
        this.dataType = ['textarea'];
        break;
      case 'DATE':
        this.dataType = ['DATE'];
        break;
      case 'StateAndCityList':
        this.dataType = ['StateAndCityList'];
        break;
      case 'CompanyList':
        this.dataType = ['CompanyList'];
        break;
      case 'CompanyFranchiseList':
        this.dataType = ['CompanyFranchiseList'];
        break;
      case 'DeviceTypeBrandModelList':
        this.dataType = ['DeviceTypeBrandModelList'];
        break;
      default:
        if (dataType.indexOf('[') !== -1) {
          let result = dataType.replace('[', '');
          result = result.replace(']', '');
          result = result.replace(/ /g, '');
          result = result.replace(/'/g, '');
          const list = result.split(',');
          this.dataType = ['select', list];
        } else {
          if (dataType.indexOf('varchar(') !== -1) {
            let result = dataType.replace('text(', '');
            result = result.replace(')', '');
            this.dataType = ['text', result];
          } else {
            if (dataType.indexOf('number(') !== -1) {
              let result = dataType.replace('number(', '');
              result = result.replace(')', '');
              this.dataType = ['text', result];
            } else {
              if (dataType.indexOf('DATE(') !== -1) {
                const originalString = dataType.toLowerCase();
                let result = originalString.replace('date(', '');
                result = result.replace(' ', '');
                const array = result.split(',');
                const minAge = array[0];
                const maxAge = array[1].replace(')', '');
                const maxAgeNumber = maxAge !== 'null' ? parseInt(maxAge, 10) : null;
                console.log('minAge creating1: ', minAge);
                const minAgeNumber = minAge !== 'null' ? parseInt(minAge, 10) : null;
                console.log('minAge creating1: ', minAge);
                result = [minAgeNumber, maxAgeNumber];
                this.dataType = ['DATE', result];
              } else {
                if (dataType.indexOf('intList(') !== -1) {
                  let maxCount = dataType.replace('\ \g', '');
                  maxCount = maxCount.replace('intList(', '');
                  maxCount = maxCount.replace(')', '');
                  this.dataType = ['intList', maxCount];
                } else {
                  console.log('not supported data type', dataType, this.id);
                }
              }
            }
          }
        }
    }
    console.log(dataType, this.dataType);
  }

  getSubQuestionList(): Question[] {
    return this.subQuesionsList;
  }
}

export class QuestionGroup {
  private readonly personalInfoQuestions: Question[];
  private readonly withSubQuestions: QuestionWithSubQuestion[];
  private readonly checkBox: Question[];

  constructor() {
    this.personalInfoQuestions = [];
    this.withSubQuestions = [];
    this.checkBox = [];
  }

  getPersonalInfoQuestions(): Question[] {
    return this.personalInfoQuestions;
  }

  getWithSubQuestions(): QuestionWithSubQuestion[] {
    return this.withSubQuestions;
  }

  getCheckBoxes(): Question[] {
    return this.checkBox;
  }
}

export class QuestionWithSubQuestion {
  constructor(private question: Question, private expanded?: boolean) {
    if (typeof expanded === 'undefined') {
      this.expanded = false;
    }
  }

  getQuestion() {
    return this.question;
  }

  isSelected() {
    return this.expanded;
  }

  setSelected(selected: boolean) {
    this.expanded = selected;
  }
}

export class CustomValidators {
  static requiredFileType(type: string[] | string) {
    return (control: FormControl) => {
      const file = control.value;
      if (file) {
        const extension: string = file.split('.')[1].toLowerCase();
        let accepted = false;
        switch (typeof type) {
          case 'object':
            type.forEach((item: string) => {
              if (item.toLowerCase() === extension.toLowerCase()) {
                accepted = true;
              }
            });
            break;
          case 'string':
            if (type.toLowerCase() === extension.toLowerCase()) {
              accepted = true;
            }
            break;
          default:
            throw new Error('not supported file type input (' + typeof type + ')');
        }
        return {
          requiredFileType: accepted
        };
      }
      return null;
    };
  }

  static fileMaxSize(maxSize: string) {
    return (control: FormControl) => {
      const file: File = control.value;
      const maxSizeArray = maxSize.split(' ');
      switch (maxSizeArray[1]) {
        case 'MB':
          if ((file.size / 1024) > parseInt(maxSizeArray[0], 10)) {
            return {
              fileMaxSize: false
            };
          } else {
            return {
              fileMaxSize: false
            };
          }
        case 'KB':
          if (file.size > parseInt(maxSizeArray[0], 10)) {
            return {
              fileMaxSize: false
            };
          } else {
            return {
              fileMaxSize: false
            };
          }
        default:
          throw new Error('file size mesure ' + maxSizeArray[1] + ' is not supported');
      }
    };
  }

  static getErrorMessage(errors: ValidationErrors) {
    // console.log(errors);
    return errors.required ? 'این فیلد اجباری می باشد' :
      errors.email ? 'ایمیل به درستی وارد نشده است' :
        'اطلاعات به درستی وارد نشده است';
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  static markFormGroupTouched(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      // console.log(control);

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  static atLeastOneValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {

    const controls = control.controls;
    if (controls) {
      const theOne = Object.keys(controls).findIndex(key => controls[key].value !== '');
      if (theOne === -1) {
        console.log(theOne);
        return {
          atLeastOneRequired: {
            text: 'At least one should be selected'
          }
        };
      }
    }
  }
}

export class User {
  constructor(public auth: string, public Role: string) {
  }
}

export class Request {
  public icon: string;

  constructor(public id: number,
              public date: string,
              public productName: string,
              public status: string) {
    this.icon = StaticMethods.getProductIcon(productName);
  }
}

export class DateMethods {
  static getJalaliDate(georgianDate: any) {
    return moment(new Date(georgianDate)).locale('fa').format('YYYY/M/D');
  }

  static getGeorgianDate(jalaliDate: any) {
    return moment.from(jalaliDate, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD');
  }
}

export class FormsModel {
  public formGroup: FormGroup;
  public questionsList: any;
  public name: string;
  public label: string;

  constructor(questionsList: any, name?: string, label?: string) {
    this.formGroup = new FormGroup({});
    this.questionsList = questionsList;
    this.label = label;
    this.name = name;
  }
}

